import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, createVNode as _createVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "timezone-popup" }
const _hoisted_2 = { class: "timezone-popup__content" }
const _hoisted_3 = { class: "input" }

import Button from "@/components/UI/Button/Button.vue";
import {onMounted, ref} from "vue";
import TimeZoneInput from "@/components/FormInput/TimeZoneInput.vue";
import TimeZonePopup from "@/ts/Popup/TimeZonePopup";
import UserService from "@/ts/User/Service/UserService";


export default /*@__PURE__*/_defineComponent({
  __name: 'TimeZonePopup',
  emits: ['create'],
  setup(__props, { emit: __emit }) {


const emit = __emit
const defaultTimeZone = Intl.DateTimeFormat().resolvedOptions().timeZone;

const timezone = ref<string>(defaultTimeZone);
const isShowed = ref(false);
const popup = ref<HTMLDivElement>();
onMounted(() => {
  const instance = TimeZonePopup.getInstance();
  instance.addOnShowListener(async () => {
    isShowed.value = true
  })
  instance.init(isShowed, popup.value!);
})

const onChoice = async () => {
  await UserService.saveTimeZone(timezone.value);
  isShowed.value = false;
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    ref_key: "popup",
    ref: popup,
    class: _normalizeClass(["popup-wrapper", {show: isShowed.value}])
  }, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _cache[2] || (_cache[2] = _createElementVNode("div", { class: "timezone-popup__title" }, "Выберите часовой пояс для корректной работы приложения", -1)),
        _cache[3] || (_cache[3] = _createElementVNode("div", { class: "timezone-popup__description" }, "Наше приложение использует ваш часовой пояс для корректной работы функций, отображения данных и уведомлений", -1)),
        _createElementVNode("div", _hoisted_3, [
          _createVNode(TimeZoneInput, {
            modelValue: timezone.value,
            "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((timezone).value = $event))
          }, null, 8, ["modelValue"])
        ]),
        _createElementVNode("div", null, [
          _createVNode(Button, {
            active: "",
            activeColor: "#6C7BB2",
            onClick: onChoice
          }, {
            default: _withCtx(() => _cache[1] || (_cache[1] = [
              _createTextVNode("Выбрать")
            ])),
            _: 1
          })
        ])
      ])
    ])
  ], 2))
}
}

})